import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

export type CaptionComponentProps = {
    /** Identifikátor labelu. Může být potřebný pro využití aria-labelledby v jiných komponentách */
    readonly id?: string;
    /** Příznak, zda je popisek zobrazen pro povinné pole. Přiznak je použit i pro postponeRequired. */
    readonly required?: boolean;
    /** Text popisku */
    readonly text?: string;
    /** Nápověda po najetí myši */
    readonly title?: string;
    /** Určuje ke kterému prvku formuláře je popisek vázán */
    readonly htmlFor?: string;
    /** Příznak, zda je popisek zobrazen jestli pole není v editaci */
    readonly alwaysShowCaption?: boolean;
    /** Příznak, zda se má text ořezávat. */
    readonly ellipsis?: boolean;
};

const classNames = bemClassNames("caption-component");

export const CaptionComponent: FunctionComponent<CaptionComponentProps> = ({
    id,
    required = false,
    text,
    title,
    htmlFor,
    alwaysShowCaption = true,
    ellipsis = false,
}) => (
    <label
        {...{ id, title, htmlFor }}
        className={classNames({
            required,
            ellipsis,
            "alwaysVisible": alwaysShowCaption,
        })}
    >
        {text}
    </label>
);
